import { IOnboardingStepProps } from "../Onboarding";

import { View } from "./View";

export const OnboardingThree = (props: IOnboardingStepProps) => {
  return <View onSubmit={props.handleNext} {...props} />;
};
